import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalSearchResponse } from '../models/global-search.model';

@Injectable({ providedIn: 'root' })
export class GlobalSearchApiService {
  private readonly http = inject(HttpClient);

  /**
   * POST /api/global-search/
   * Returns quotes and users matching the given search term.
   */
  globalSearch(term: string): Observable<GlobalSearchResponse> {
    return this.http.post<GlobalSearchResponse>(
      `${environment.base_url}global-search/`,
      { search: term }
    );
  }
}
